import { useState } from 'react'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { InputText } from '#app/components/ui/input-text'

interface LocadorData {
	locadorNombre: string
	locadorDocumento: string
	locadorDomicilio: string
}

interface CaucionAlquilerLocadorScreenProps {
	onNext: (data: LocadorData) => void
	onBack: () => void
	data?: Partial<LocadorData>
}

export function CaucionAlquilerLocadorScreen({
	onNext,
	onBack,
	data,
}: CaucionAlquilerLocadorScreenProps) {
	const [formData, setFormData] = useState<LocadorData>({
		locadorNombre: data?.locadorNombre || '',
		locadorDocumento: data?.locadorDocumento || '',
		locadorDomicilio: data?.locadorDomicilio || '',
	})

	const [errors, setErrors] = useState<Record<string, string>>({})

	const handleSubmit = () => {
		const newErrors: Record<string, string> = {}

		if (!formData.locadorNombre.trim()) {
			newErrors.locadorNombre = 'Ingresa el nombre del locador'
		}
		if (!formData.locadorDocumento.trim()) {
			newErrors.locadorDocumento = 'Ingresa el CUIT/DNI'
		}
		if (!formData.locadorDomicilio.trim()) {
			newErrors.locadorDomicilio = 'Ingresa el domicilio'
		}

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors)
			return
		}

		onNext(formData)
	}

	const isFormValid =
		formData.locadorNombre.trim() &&
		formData.locadorDocumento.trim() &&
		formData.locadorDomicilio.trim()

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-8">
					<h2 className="font-parkinsans text-center text-2xl leading-8 font-medium text-blue-800">
						Datos del Locador
						<br />
						<span className="text-lg text-neutral-600">(Propietario)</span>
					</h2>

					<div className="flex w-full flex-col gap-4">
						<InputText
							label="Nombre y Apellido / Razón Social"
							labelPosition="internal"
							size="l"
							placeholder="Nombre del propietario"
							value={formData.locadorNombre}
							onChange={(e) => {
								setFormData({ ...formData, locadorNombre: e.target.value })
								setErrors({ ...errors, locadorNombre: '' })
							}}
							errorText={errors.locadorNombre}
							required
						/>
						<InputText
							label="CUIT / DNI"
							labelPosition="internal"
							size="l"
							placeholder="Documento del propietario"
							value={formData.locadorDocumento}
							onChange={(e) => {
								setFormData({ ...formData, locadorDocumento: e.target.value })
								setErrors({ ...errors, locadorDocumento: '' })
							}}
							errorText={errors.locadorDocumento}
							required
						/>
						<InputText
							label="Domicilio"
							labelPosition="internal"
							size="l"
							placeholder="Dirección del propietario"
							value={formData.locadorDomicilio}
							onChange={(e) => {
								setFormData({ ...formData, locadorDomicilio: e.target.value })
								setErrors({ ...errors, locadorDomicilio: '' })
							}}
							errorText={errors.locadorDomicilio}
							required
						/>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="ghost"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Atrás
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={handleSubmit}
					disabled={!isFormValid}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Siguiente
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
